import ConfigBox from './ConfigBox';
export default ConfigBox;


// WEBPACK FOOTER //
// ./src/components/ConfigBox/index.js